// extracted by mini-css-extract-plugin
module.exports = {"textarea":"TextareaAutosize_textarea___KPQN","error":"TextareaAutosize_error__S5iAA","fullHeight":"TextareaAutosize_fullHeight__En7u4"};